import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { CommonConstant } from '../utilities/common-constant';
// import { RouteHandlerService } from '../shared/services/route-handler.service';
import { StorageHandlerService } from '../services/storage-handler.service';

export enum ThemeMode {
  DARK,
  LIGHT,
}

@Injectable()
export class UiStyleService {

  public theme$ = new BehaviorSubject<ThemeMode>(ThemeMode.LIGHT);
  private readonly THEME_KEY = CommonConstant.ThemeConfig.theme;
  private readonly DARK_THEME_VALUE = CommonConstant.ThemeConfig.dark;
  private readonly LIGHT_THEME_VALUE = CommonConstant.ThemeConfig.light;
  private readonly DARK_THEME_CLASS_NAME = CommonConstant.ThemeConfig.themeDark;
  private readonly LIGHT_THEME_CLASS_NAME = CommonConstant.ThemeConfig.themeLight;
  private darkThemeSelected = true;

  constructor(
    // private routeHandlerService: RouteHandlerService,
    private route: ActivatedRoute,
    private storageHandlerService: StorageHandlerService
  ) {}

  public setThemeOnStart() {
    this.setLightTheme();
  }

  public toggle() {
    if (this.darkThemeSelected) {
      this.setLightTheme();
    } else {
      this.setDarkTheme();
    }
  }

  private setLightTheme() {
    this.storageHandlerService.set(this.THEME_KEY, this.LIGHT_THEME_VALUE);
    document.body.classList.remove(this.DARK_THEME_CLASS_NAME);
    document.body.classList.add(this.LIGHT_THEME_CLASS_NAME);
    this.darkThemeSelected = false;
    this.theme$.next(ThemeMode.LIGHT);
  }

  private setDarkTheme() {
    this.storageHandlerService.set(this.THEME_KEY, this.DARK_THEME_VALUE);
    document.body.classList.remove(this.LIGHT_THEME_CLASS_NAME);
    document.body.classList.add(this.DARK_THEME_CLASS_NAME);
    this.darkThemeSelected = true;
    this.theme$.next(ThemeMode.DARK);
  }
}
